module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/kitchen-sink/kitchen-sink.component.css
// module id = ./src/app/examples/kitchen-sink/kitchen-sink.component.css
// module chunks = main